var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.16267 0 0 7.164 0 16C0 24.836 7.16267 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM16.1867 25.3573C11.0293 25.3573 6.85333 21.1707 6.85333 16C6.85333 10.8293 11.0293 6.64267 16.1867 6.64267C18.7067 6.64267 20.8133 7.572 22.4293 9.08133L19.7973 11.7187V11.7133C18.8173 10.7773 17.5747 10.2973 16.1867 10.2973C13.1067 10.2973 10.604 12.9053 10.604 15.9947C10.604 19.0813 13.1067 21.6973 16.1867 21.6973C18.9813 21.6973 20.8827 20.0947 21.2747 17.8947H16.1867V14.2453H24.9667C25.084 14.872 25.1467 15.5253 25.1467 16.2107C25.1467 21.5573 21.5773 25.3573 16.1867 25.3573Z",
    fill: "#2D89FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGoogle);
export default __webpack_public_path__ + "static/media/icons_google.932fb5926c477c064de90646e26440c3.svg";
export { ForwardRef as ReactComponent };